import { FormatOverline, InfoOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Alert,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  OutlinedInput,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as ROUTES from "../constants/Routes";
import * as PATTERNS from "../constants/patterns";
import { withFirebase } from "../Firebase";
import LangSelect from "./LangSelect";
import ReCAPTCHA from "react-google-recaptcha";

const RegisterForm = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { firebase } = props;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [psw1, setPsw1] = useState("");
  const [psw2, setPsw2] = useState("");
  const [psw2focused, setPsw2focused] = useState(false);
  const [key, setKey] = useState("");
  const [phone, setPhone] = useState("");
  const [formError, setFormError] = useState({});
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState("");
  const [address, setAddress] = useState("");
  const [requestError, setRequestError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [policyAccept, setPolicyAccept] = useState(false);
  const [openPolicy, setOpenPolicy] = useState(false);

  const checkNotNull = (value, field) => {
    var aux = formError;
    value = value.trim();
    aux[field] = value == "" ? t("notEmptyField") : null;
    updateformError(aux);
  };

  const updateformError = (aux) => {
    var elem = {};
    Object.keys(aux).forEach((k) => (elem[k] = aux[k]));
    setFormError(elem);
  };

  const checkEmail = (email) => {
    var aux = formError;
    const rege = new RegExp(PATTERNS.EMAIL);
    if (email == "") {
      checkNotNull(email, "email");
    } else {
      aux["email"] = !rege.test(email) ? t("invalidEmailFormt") : null;
    }
    updateformError(aux);
  };

  const checkPhone = (value) => {
    var aux = formError;
    const rege1 = new RegExp("^[+]?[(]?[0-9]{1,3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}$");
    const rege2 = new RegExp("^([+]*[(][0-9]{1,3}[)])?([+]*[0-9]{2})?[\\s]?([0-9]{2,4}[\\s.-]?){2,4}$");

    if (value !== "") {
      if (rege1.test(value) || rege2.test(value)) {
        aux["phoneNumber"] = null;
      } else {
        aux["phoneNumber"] = t("invalidPhoneFormt");
      }
      // necesario para actualiar el estado en el mismo ciclo
      updateformError(aux);
    } else {
      aux["phoneNumber"] = null;
      updateformError(aux);
    }
  };

  const checkPassword = (pw1, pw2) => {
    var aux = formError;
    if (psw1.length < 6 && psw1 != "") {
      aux["psw1"] = t("lengthlessthan6");
    } else if (psw2 !== psw1 && psw2focused) {
      aux["psw1"] = t("passwordNoMatch");
      aux["psw2"] = t("passwordNoMatch");
    } else {
      aux["psw1"] = null;
      aux["psw2"] = null;
    }
    updateformError(aux);
  };

  useEffect(() => {
    const listener = firebase.auth.onAuthStateChanged((authUser) => {
      !!authUser && navigate(ROUTES.HOME);
    });

    return () => {
      listener();
    };
  }, []);

  const isValid =
    name !== "" &&
    email !== "" &&
    key !== "" &&
    psw1 !== "" &&
    psw2focused &&
    psw1 === psw2 &&
    policyAccept &&
    Object.keys(formError).every((k) => formError[k] === null);

  const CreateUser = () => {
    setLoading(true);
    firebase
      .doCreateUserWithEmailAndPassword(email, psw1, name, phone, key, company, address, i18n.language)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        if (err === undefined) {
          setRequestError(true);
        } else {
          var aux = formError;
          switch (err.code) {
            case "auth/invalid-phone-number":
              aux["phoneNumber"] = t(err.code);
              break;
            /*case "auth/invalidCode":
              aux["key"] = t(err.code);
              break;*/
            case "auth/email-already-exists":
              aux["email"] = t(err.code);
              break;
            case "auth/invalid-email":
              aux["email"] = t(err.code);
              break;
            case "auth/invalid-display-name":
              aux["name"] = t(err.code);
              break;
            case "auth/invalid-password":
              aux["psw1"] = t(err.code);
              aux["psw2"] = t(err.code);
              break;
            case "auth/addressTooLong":
              aux["address"] = t(err.code);
              break;
            case "auth/companyTooLong":
              aux["company"] = t(err.code);
              break;
            case "request/error":
              setRequestError(true);
              break;
          }
          updateformError(aux);
        }
        setTimeout(() => {
          setLoading(false);
        }, 750);
      });
  };

  const handleClose = () => {
    setRequestError(false);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} container spacing={2}>
        <Grid item xs={12} container direction={"row"} justifyContent={"space-between"}>
          <Typography variant="h6" color={"GrayText"}>
            {t("createYourAccount")} *
          </Typography>
          <LangSelect />
        </Grid>
        {/*
          <Grid item xs={12} sm={6} md={12}>
            <FormControl fullWidth>
              <InputLabel error={!!formError.key}>{t("code")}</InputLabel>
              <OutlinedInput
                id="outlined-adornment-amount"
                value={key}
                error={!!formError.key}
                onChange={(e) => {
                  e = e.target.value;
                  setKey(e);
                  !!formError.key && checkNotNull(e, "key");
                }}
                onBlur={() => {
                  setKey(key.trim());
                  checkNotNull(key, "key");
                }}
                required
                endAdornment={
                  <InputAdornment position="end">
                    <Tooltip title={<Typography>{t("keyNoteTooltip")}</Typography>}>
                      <IconButton>
                        <InfoOutlined />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                }
                label={t("code")}
              />
              <FormHelperText error>{formError.key}</FormHelperText>
            </FormControl>
          </Grid>
            */}
        <Grid item xs={12} sm={6}>
          <TextField
            id="name"
            label={t("name")}
            variant="outlined"
            value={name}
            required
            onBlur={() => {
              setName(name.trim());
              checkNotNull(name, "name");
            }}
            helperText={formError.name}
            error={!!formError.name}
            onChange={(e) => {
              e = e.target.value;
              !!e && setName(e.slice(0, 69));
              !!formError.name && checkNotNull(e, "name");
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="phone"
            value={phone}
            helperText={formError.phoneNumber}
            error={!!formError.phoneNumber}
            onBlur={(e) => {
              checkPhone(e.target.value);
            }}
            onChange={(e) => {
              e = e.target.value;
              setPhone(e);
              !!formError.phoneNumber && checkPhone(e);
            }}
            type="tel"
            label={t("phone")}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            id="company"
            value={company}
            helperText={formError.company}
            error={!!formError.company}
            label={t("company")}
            variant="outlined"
            onChange={(e) => {
              setCompany(e.target.value); //.slice(0, 254)
              let aux = formError;
              aux["company"] = e.target.value.length > 254 ? t("auth/companyTooLong") : null;
              updateformError(aux);
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            id="address"
            value={address}
            helperText={formError.address}
            error={!!formError.address}
            label={t("address")}
            variant="outlined"
            onChange={(e) => {
              setAddress(e.target.value);
              let aux = formError;
              aux["company"] = e.target.value.length > 254 ? t("auth/companyTooLong") : null;
              updateformError(aux);
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <TextField
            id="email"
            type={"email"}
            label={t("email")}
            required
            variant="outlined"
            value={email}
            helperText={formError.email}
            error={!!formError.email}
            onChange={(e) => {
              setEmail(e.target.value);
              !!formError.email && checkEmail(e.target.value);
            }}
            onBlur={() => checkEmail(email)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl error={!!formError.psw1} fullWidth>
            <InputLabel required>{t("password")}</InputLabel>
            <OutlinedInput
              id="pass1"
              label={t("password")}
              type={showPassword ? "text" : "password"}
              required
              variant="outlined"
              fullWidth
              value={psw1}
              error={!!formError.psw1}
              onChange={(e) => {
                e = e.target.value;
                setPsw1(e);
                !!formError.psw1 && checkPassword(e, psw2);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    // aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
              onBlur={() => checkPassword(psw1, psw2)}
            />
            <FormHelperText error>{formError.psw1}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl error={!!formError.psw2} fullWidth>
            <InputLabel required error={!!formError.psw2}>
              {t("repeatPassword")}
            </InputLabel>
            <OutlinedInput
              id="pass2"
              label={t("repeatPassword")}
              type={showPassword ? "text" : "password"}
              required
              variant="outlined"
              fullWidth
              value={psw2}
              error={!!formError.psw2}
              onChange={(e) => {
                e = e.target.value;
                setPsw2(e);
                setPsw2focused(true);
                !!formError.psw2 && checkPassword(psw1, e);
              }}
              onBlur={() => checkPassword(psw1, psw2)}
              onFocus={() => {
                setPsw2focused(true);
              }}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
            <FormHelperText error>{formError.psw2}</FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={<Checkbox checked={policyAccept} onChange={() => setPolicyAccept(!policyAccept)} name="policy" color="primary" />}
            label={
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  setOpenPolicy(true);
                }}
              >
                {t("Acepto la política de privacidad")}
              </Link>
            }
          />
        </Grid>
        {
          <Grid item xs={12} container justifyContent={"center"}>
            <ReCAPTCHA
              size="normal"
              sitekey="6Lc4AIYgAAAAAA8pgWBU12aWmXMTo8N3YVM5XgwU"
              style={{ alignSelf: "center" }}
              onChange={(token) => {
                setKey(token);
              }}
              onError={() => setKey("")}
              onExpired={() => setKey("")}
            />
          </Grid>
        }
        <Grid item xs={12}>
          <Button fullWidth variant="contained" disabled={!isValid || loading} onClick={CreateUser}>
            {t("createAccount")}
            {loading && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
          </Button>
          {/* <Typography variant="body2" color={"GrayText"} style={{ marginTop: 6 }}>
            {t("aceptPolicy")}
            {
              <Link
                href="#"
                underline="none"
                onClick={() => {
                  navigate(ROUTES.POLICY);
                }}
              >
                {t("privacyPolicy")}
              </Link>
            }
        </Typography>*/}
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Button
          fullWidth
          variant="text"
          onClick={() => {
            navigate(ROUTES.SIGN_IN);
          }}
        >
          {t("alreadyHaveAnAccount")}
        </Button>
      </Grid>
      <Snackbar open={requestError} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          {t("request/error")}
        </Alert>
      </Snackbar>
      <Dialog open={openPolicy} maxWidth={"md"} fullWidth>
        <DialogTitle>{t("privacyPolicy")}</DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Osatu S. Coop. se compromete a proteger la privacidad de sus usuarios. Esta declaración de privacidad no aplica ni a la página
              corporativa
              <a href="https://www.bexencardio.com"> www.bexencardio.com</a>, ni a ningún otro subdominio de bexencardio.com, ni aplica a
              Osatu S. Coop. en el contexto de sus actividades corporativas. Esta política de privacidad únicamente aplica a la app Reanibex
              Alert. Para más información sobre la política de esas páginas, puede acceder al sitio web que las contenga.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué información se recoge de los usuarios?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Los usuarios no registrados no tienen acceso al área privada de la app Reanibex Alert y por tanto no se recogen datos de
              ningún tipo. En el caso de los usuarios registrados los datos que se recogen incluyen: email para la cuenta de usuarios,
              localización, e identificador de notificaciones para el móvil.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Esta app en ningún caso recolecta información de pacientes, ni datos biométricos y/o de salud de sus usuarios. Limitándose a
              ser un sistema de aviso para ayudar a mejorar los tiempos de respuesta en eventos cardiacos que se puedan producir fuera del
              ámbito hospitalario.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Porqué me pide acceder a mi ubicación en segundo plano?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La principal tarea de Reanibex Alert es la de avisar a los usuarios más cercanos de la posible parada cardiorrespiratoria de
              una persona para que los usuarios más cercanos acudan a ayudarle.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Por tanto, Reanibex Alert accede a la ubicación del usuario en segundo plano para poder avisarle de una parada
              cardiorrespiratoria cuando es el usuario que más cerca esté de la persona que necesita ayuda.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Para que los usuarios puedan ir a ayudar en una parada cardiorrespiratoria es necesario que reciban un aviso,
              independientemente de si están usando o no la aplicación en ese momento. Este aviso sólo se puede dar si la aplicación sabe
              que el usuario está cerca de la parada cardiorrespiratoria.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La aplicación Reanibex Alert accede a la ubicación en segundo plano únicamente en el momento en el que se produce el aviso –
              se manda una notificación al móvil que inicia el acceso a la ubicación - , y en ningún momento accederá a la ubicación en
              segundo plano si no se ha producido un evento cardiorrespiratorio
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Los datos de ubicación únicamente se utilizan para calcular la cercanía del usuario a una parada cardiorrespiratoria en el
              momento en el que se está produciendo. Estos datos no son almacenados ni usados para ningún otro fin o procesamiento.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Para qué se usa la información recolectada?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La app Reanibex Alert es usada por usuarios con formación en cardioprotección para ayudar durante eventos cardiológicos.
              Cuando hay un evento, los usuarios activos más cercanos a un evento son avisados para que acudan a la zona a ayudar en las
              labores de asistencia.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Debido a las características de la app, y para poder dar el servicio descrito es necesario recoger los datos indicados en el
              apartado anterior. En concreto se recogen:
            </Typography>
            <ul>
              <li>
                Email: a modo de identificador de cuenta de usuario y que sólo personas con la formación adecuada puedan acceder a ella.
              </li>

              <li>
                Localización: para poder mejorar los tiempos de respuesta a un evento – crítico en el ámbito de la cardioprotección – es
                necesario conocer qué usuarios están más cerca del evento, aunque no tenga la app en primer plano, y así avisar a los que
                estén más cerca y/o dentro del rango de actuación.
              </li>
              <li>
                Identificador de móvil para notificaciones: con el fin de mandar notificaciones/avisos a los usuarios es necesario
                distinguir entre los diferentes móviles que tienen acceso a la aplicación, ya que se enviarán notificaciones a aquellos
                usuario que estén más cerca de un evento.
              </li>
            </ul>

            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Con quién se comparte la información?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Osatu S. Coop. usa proveedores de servicios Cloud - Google Inc. - para poder llevar a cabo las tareas de funcionamiento básico
              de la app:
            </Typography>
            <ul>
              <li>Gestión de usuarios</li>
              <li>Gestión de flota de desfibriladores</li>
              <li>Gestión de notificaciones y calculo de cercanía al evento</li>
            </ul>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              En cualquier caso, no se comparten directamente datos de usuarios con los proveedores de servicios contratados, sino que se
              usan sus servicios para el procesado y almacenamiento de datos, pero el procesado y almacenamiento siempre lo realiza Osatu S.
              Coop. y así poder llevar a cabo el servicio contratados/solicitados
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              En todos los casos los servicios que procesan los datos y el almacenamiento de estos - necesarios para llevar las tareas de
              funcionamiento de la app - se encuentran ubicados dentro de la UE, y ningún dato es transmitido a países de terceros
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Por tanto, Osatu S. Coop. no comparte información con terceros fuera de los proveedores – los indicados al inicio de esta
              sección – de servicio subcontratadas que le permiten dar el servicio definido en la descripción del producto en la Play Store
              de Google.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué derechos tiene como usuario?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Los usuarios registrados tienen derecho al acceso, modificación y olvido de los datos personales, pero no para los datos de
              otros usuarios.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Puesto que dicha cuenta está ligada a una plataforma de formación, el usuario dispondrá de las herramientas necesarias para
              eliminar y modificar los datos de usuario en ella – y cuyo acceso precede al posible uso de la app - . Si el usuario requiere
              acceso a más datos de los que se muestran en su cuenta dentro de la plataforma, este podrá enviar un email a{" "}
              <Link>info@bexencardio.com</Link> para poder acceder a ellos.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h4" style={{ marginTop: 12 }}>
              Política de Cookies
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué es una Cookie?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Una cookie es un fichero inofensivo que se almacena en navegadores web y algunas app, y que se almacena en ellos cada vez que
              se accede a un sitio web. Por ejemplo, para mantener una sesión de usuario o para guardar preferencias de un sitio. En algunos
              casos también se llegan a utilizar para fines publicitarios.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué tipo de Cookies se usan?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La app Reanibex Alert no usa datos de cookies, aunque usa herramientas similares – tokens – cuya única finalidad es la de
              mantener la sesión de usuario activa durante el uso de la aplicación.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              La app Reanibex Alert no usa cookies de ningún otro tipo, y no utiliza cookies con fines estadísticos, publicitarios, creación
              de perfiles, ni de marketing.
            </Typography>
            <Typography variant="h6" style={{ marginTop: 12 }}>
              ¿Qué ocurre si bloqueo las Cookies?
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Puesto que esta aplicación no usa cookies, es posible seguir utilizando la app sin problemas. Si bien, en algunos navegadores
              es posible que no pueda iniciar sesión o tenga dificultades manteniendo la sesión abierta. Existen opciones en los diferentes
              navegadores que le permite filtrar el tipo de cookies a bloquear.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h4" style={{ marginTop: 12 }}>
              Aviso Legal
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              De acuerdo a lo establecido en el artículo 10 de la Ley Española 34/2002, del 11 de julio, sobre los servicios de (LSSICE),
              los datos identificativos de la empresa se muestras más abajo.
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Osatu S.Coop, Edificio Zearrekobuelta, Subida de Areitio, 5, 48260 Ermua (Vizcaya) - España
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>
              Telefon: +34 943 170 220 ó +34 943 170 266 / Fax. +34 943 170 227
            </Typography>
            <Typography style={{ textAlign: "justify", marginTop: 9 }}>E-mail: info@bexencardio.com</Typography>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="error" onClick={() => setOpenPolicy(false)}>
            {t("close")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenPolicy(false);
              setPolicyAccept(true);
            }}
          >
            {t("acept")}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default withFirebase(RegisterForm);
